/** Regelversion 7: Parteispenden, Vorwahlkampf mit TV-Duellen, verfallene Entwürfe. */
import { useGame, useS } from '../../store/game';
import { Panel } from '../../components/ui';
import { Illu } from '../../components/Illu';
import { DON_OPTS, donOn } from '../../engine/don';
import { preDue, preOn } from '../../engine/pre';
import { reDraftBlock } from '../../engine/lapsed';
import { PA, PN } from '../../engine/rules';
import { ISS } from '../../content/states';
import { de, dateLabel, sg } from '../../engine/util';
import { since } from '../../engine/version';

/** Angebot einer Großspende. */
export function DonOfferCard() {
  const S = useS(); const { dispatch } = useGame(); const O = S.donOffer; if (!O) return null;
  const risky = O.amt >= 1;
  return (
    <div className="decision hotd"><Illu src="/img/moment/spende.webp" className="illu card" /><span className="label">Parteispende · {dateLabel(S.m)}</span>
      <h3>{de(O.amt, 1)} Mio € für die Wahlkampfkasse</h3>
      <span className="sub">{O.by} möchte eure Partei unterstützen. Große Spenden müssen sofort veröffentlicht werden.{risky ? ' Bei so einer Summe schauen Presse und Opposition genau hin.' : ''}</span>
      <div className="copts">{DON_OPTS.map(([l, d], i) => <button type="button" key={i} className="copt" onClick={() => dispatch('donAnswer', i)}><b>{l}</b><span className="sub">{d}</span></button>)}</div>
    </div>
  );
}

/** Wahlkampfkasse (Reiter „Stimmung“). */
export function DonPanel() {
  const S = useS(); if (!donOn()) return null;
  const d = S.don || { pot: 0, big: [], heat: 0 }, big = (d.big || []).reduce((s: number, b: any) => s + b.amt, 0);
  return (
    <Panel title="Wahlkampfkasse" aside={`${de(d.pot || 0, 1)} Mio € angespart`} className="donbox">
      <span className="sub">Spenden aus dieser Legislatur fließen in den nächsten Wahlkampf, zusätzlich zu Mitgliedsbeiträgen und staatlicher Teilfinanzierung.</span>
      {big > 0 && <span className={'sub ' + (d.heat >= .3 ? 'down' : 'warn')}>Großspenden: {de(big, 1)} Mio €. {d.heat >= .3 ? 'Journalisten recherchieren bereits zu euren Geldgebern.' : 'Noch fragt niemand nach.'}</span>}
      {(d.hit || 0) > 0 && <span className="sub down">Spendenaffären bisher: {d.hit}</span>}
    </Panel>
  );
}

/** Das TV-Duell, das gerade ansteht. */
export function PreDuelCard() {
  const S = useS(); const { dispatch } = useGame(); const d = preDue(); if (!d || !d.q.length) return null;
  const k = d.ans.length, q = d.q[k], last = d.ans[k - 1];
  return (
    <div className="decision hotd preduel"><Illu src="/img/moment/tvduell.webp" className="illu card" /><span className="label">Vorwahlkampf · TV-Duell {S.pre.duels.indexOf(d) + 1} von {S.pre.duels.length} · Frage {k + 1} von {d.q.length}</span>
      <h3>Gegen {PN(d.opp)}</h3>
      {last && <span className={'sub ' + (last.v > 0 ? 'up' : last.v < 0 ? 'down' : '')}>{last.t}</span>}
      <p className="q">{q.q}</p>
      <div className="copts">{q.o.map((o: any, i: number) => <button type="button" key={i} className="copt" onClick={() => dispatch('preAnswer', i)}><b>{o.l}</b></button>)}</div>
    </div>
  );
}

/** Überblick über den Vorwahlkampf (Reiter „Presse“). */
export function PrePanel() {
  const S = useS(); if (!preOn() || !S.pre || S.pre.leg !== S.leg) return null;
  const P = S.pre;
  return (
    <Panel title="Vorwahlkampf" aside={P.tot ? `${sg(P.tot, 1)} Punkte in den Umfragen` : 'TV-Duelle'} className="prebox">
      <div className="duels">{P.duels.map((d: any, i: number) => (
        <div key={i} className={'duel' + (d.done ? (d.poll >= 50 ? ' won' : ' lost') : '')}>
          <b>{PA(d.opp)}</b>
          {d.done ? <><span className="num">{d.poll} : {100 - d.poll}</span><span className="sub">{d.poll >= 50 ? 'Ihr habt überzeugt' : `${PA(d.opp)} hat überzeugt`}</span></>
            : <span className="sub">{S.m >= d.at ? 'läuft gerade' : dateLabel(d.at)}</span>}
        </div>))}</div>
      {P.prom.length > 0 && <span className="sub">Im Duell versprochen: {P.prom.map((p: any) => p.t).join(' · ')}. Daran werdet ihr im Wahlkampf gemessen.</span>}
    </Panel>
  );
}

/** Entwürfe, die mit der letzten Legislatur verfallen sind (Reiter „Lage“). */
export function LapsedPanel() {
  const S = useS(); const { dispatch } = useGame();
  if (!since(7) || !(S.lapsed || []).length || S.phase !== 'govern') return null;
  const STG: Record<string, string> = { draft: 'im Ministerium', ready: 'kabinettsreif', coord: 'in der Ressortabstimmung', bt: 'im Bundestag', br: 'im Bundesrat', vm: 'im Vermittlungsausschuss', failed: 'gescheitert', blocked: 'blockiert' };
  return (
    <Panel title="Aus der letzten Legislatur" aside={`${S.lapsed!.length} verfallen`} className="lapsedbox">
      <span className="sub">Mit der neuen Legislatur sind unfertige Gesetze verfallen. Ihr könnt sie mit denselben Einstellungen neu einbringen. Das Verfahren beginnt dann wieder im Ministerium.</span>
      <div className="lapsed">{S.lapsed!.map((X: any, i: number) => { const why = reDraftBlock(X); return (
        <div key={i} className="lrow"><div className="mi"><b>{X.t}</b><span className="sub">{ISS[X.iss]?.n ?? ''}{STG[X.stage] ? ` · war ${STG[X.stage]}` : ''}</span></div>
          {why ? <span className="sub">{why}</span> : <button type="button" className="small" onClick={() => dispatch('reDraft', i)}>Neu einbringen</button>}
        </div>); })}</div>
    </Panel>
  );
}
